import styles from './FeedbackHero.module.css';

export default function FeedbackHero() {
  return (
    <section className={styles.hero}>
      <div className={styles.inner}>
        <span className={styles.eyebrow}>Feedback</span>
        <h1 className={styles.headline}>Tell us how it's going.</h1>
        <p className={styles.sub}>
          Rate the features you've tried and let us know what you like and what needs work.
          Your feedback shapes what we build next.
        </p>
      </div>
    </section>
  );
}
